import './Page.css'
import React from "react";

export default function PageContent({ children }) {
    return (
        <div id='page-content' className='pageContentInner pt-l pb-l'>
            {children}
        </div>
    )
}
